import * as pages from '../../common_constants/Pages'
import NavigationService from '../../support/navigation/NavigationService'

export const getNavbarPaths = () => {
  const ROUTES = NavigationService.getRoutes()

  return {
    explore: ROUTES[pages.EXPLORE_PAGE].path,
    allIdeas: ROUTES[pages.ALL_IDEAS].path,
    myIdeas: ROUTES[pages.MY_IDEAS_PAGE].path,
    myInvestedIdeas: ROUTES[pages.MY_INVESTED_IDEAS].path,
    challenges: ROUTES[pages.CHALLENGES_PAGE].path,
    novaResearch: ROUTES[pages.NOVA_RESEARCH].path,
    aboutUs: ROUTES[pages.ABOUT_US].path,
    caseStudy: ROUTES[pages.CASESTUDY].path,
    bench: ROUTES[pages.THEBENCH].path,
    contactUs: ROUTES[pages.CONTACTUS].path,
    scoreCardTemplate: ROUTES[pages.SCORECARDTEMPLATE].path,
    ideaTemplate: ROUTES[pages.IDEATEMPLATE].path,
  }
}

export const getNavbarItems = ({
  paths,
  isAdmin,
  isInnovator,
  isHackathonEnable,
}) => [
  {
    path: paths.explore,
    title: 'Home',
  },
  {
    path: '/',
    title: 'Ideas',
    sub: [
      {
        path: paths.myIdeas,
        title: 'My ideas',
      },
      {
        path: paths.allIdeas,
        title: 'All ideas',
      },
      ...(!isHackathonEnable
        ? [
            {
              path: paths.myInvestedIdeas,
              title: 'My invested ideas',
            },
          ]
        : []),
    ],
  },
  {
    path: '/',
    title: 'Challenges',
    sub: [
      {
        path: paths.challenges,
        title: 'All challenges',
      },
      {
        path: '#',
        title: 'New challenge',
        isModalTrigger: true,
        adminRole: isAdmin || isInnovator,
      },
    ],
  },
  {
    path: paths.bench,
    title: 'Bench',
  },
  ...(isAdmin || isInnovator
    ? [
        {
          path: '/',
          title: 'Templates',
          sub: [
            {
              path: paths.ideaTemplate,
              title: 'Idea Templates',
            },
            {
              path: paths.scoreCardTemplate,
              title: 'Scorecard Templates',
            },
          ],
        },
      ]
    : []),
  ...(!isHackathonEnable
    ? [
        {
          path: paths.caseStudy,
          title: 'Case studies',
        },
      ]
    : []),
  {
    path: '/',
    title: 'Help',
    sub: isHackathonEnable
      ? [
          {
            path: paths.contactUs,
            title: 'Contact Us',
          },
        ]
      : [
          {
            path: paths.aboutUs,
            title: 'About NOVA',
          },
          {
            path: paths.novaResearch,
            title: 'NOVA Research',
          },
          {
            path: paths.contactUs,
            title: 'Contact Us',
          },
        ],
  },
  ...(!isHackathonEnable
    ? [
        {
          path: '/',
          title: 'Access Requests',
          buttonEle: true,
          sub: [
            { id: 'VOIS', name: 'Vois' },
            { id: 'eris', name: 'Nova' },
          ],
        },
      ]
    : []),
]